import { baseApi } from '@/services'
import { Company } from '@/types/unlock'

export const companiesApi = baseApi.injectEndpoints({
  endpoints: (builder) => ({
    listCompanies: builder.query<Company[], void>({
      query: () => 'v2/companies/',
      providesTags: () => ['Companies'],
    }),
    createCompany: builder.mutation<Company, { data: Partial<Company> }>({
      query: ({ data }) => ({
        url: `v2/companies/`,
        method: 'POST',
        body: data,
      }),
      invalidatesTags: ['Companies'],
    }),
    updateCompany: builder.mutation<Company, { uuid: string; data: Partial<Company> }>({
      query: ({ uuid, data }) => ({
        url: `v2/companies/${uuid}/`,
        method: 'PATCH',
        body: data,
      }),
      invalidatesTags: ['Companies'],
    }),
    deleteComapny: builder.mutation<Company, string>({
      query: (uuid) => ({
        url: `v2/companies/${uuid}/`,
        method: 'DELETE',
      }),
      invalidatesTags: ['Companies'],
    }),
  }),
})

export const {
  useListCompaniesQuery,
  useCreateCompanyMutation,
  useUpdateCompanyMutation,
  useDeleteComapnyMutation,
} = companiesApi
